module.exports = __webpack_public_path__ + "static/3BHK-05-Bathroom-616c2b62d49cb2cb6ba25e25ae474060.jpg";